export default "__VITE_ASSET__b7f7b934__"